export function implode(separator: string, ...array: (number | string | null | undefined)[]): string {
  return array.filter((v) => !!v).join(separator);
}
